import fs from 'node:fs';
import path from 'node:path';
import { MicrofrontendError } from '../../errors';

/**
 * Returns the application name and any additional context that we need.
 */
export function getApplicationContext(opts?: {
  appName?: string;
  packageRoot?: string;
}): {
  name: string;
} {
  if (opts?.appName) {
    return { name: opts.appName };
  }

  // If this is NX, there are many different places the name can be and they
  // might not even have a package.json. Use the environment variable, which
  // relies on NX's logic to find the name.
  if (process.env.NX_TASK_TARGET_PROJECT) {
    return { name: process.env.NX_TASK_TARGET_PROJECT };
  }

  try {
    // load the package.json for the application
    const packageJsonString = fs.readFileSync(
      path.join(opts?.packageRoot || '.', 'package.json'),
      'utf-8',
    );
    const packageJson = JSON.parse(packageJsonString) as { name?: string };

    if (!packageJson.name) {
      throw new MicrofrontendError(
        `package.json file missing required field "name"`,
        {
          type: 'packageJson',
          subtype: 'missing_field_name',
          source: '@vercel/microfrontends/next',
        },
      );
    }

    return { name: packageJson.name };
  } catch (err) {
    throw MicrofrontendError.handle(err, {
      fileName: 'package.json',
    });
  }
}
